export default __webpack_public_path__ + "static/media/Macro2_rock_grout.b906127c.png";